import styled from "styled-components";

export const StatusBadge = styled.span`
    padding: 8px 16px;
    border-radius: 16px;
    display: block;
    font-size: 12px;
    text-transform: capitalize;
    text-align: center;

    & .fund-name
    {
        text-transform: uppercase;
    }
    & .price-no-wrap
    {
        white-space: nowrap;
    }
    &.procesando
    {
        color: ${(props) => props.theme.palette.warnSecondary+ " !important"};
        font-weight: bolder;
    }
    &.enviada
    {
        color: ${(props) => props.theme.palette.neutralTertiary+ " !important"};
        font-weight: bolder;
    }
    &.error
    {
        color: ${(props) => props.theme.palette.themePrimary + " !important"};
        font-weight: bolder;
    }
    &.aviso
    {
        color: ${(props) => props.theme.palette.alertSecondary + " !important"};
        font-weight: bolder;
    }
    &.validada
    {
        color: blue !important;
        font-weight: bolder;
    }
    &.finalizado
    {
        color: ${(props) => props.theme.palette.correctPrimary + " !important"};
        font-weight: bolder;
    }
    &.cancelada
    {
        color: ${(props) => props.theme.palette.themePrimary + " !important"};
        font-weight: bolder;
    }
    &.completada
    {
        color: ${(props) => props.theme.palette.themeLighter + " !important"};
        font-weight: bolder;
    }
    &.pendiente
    {
        color: ${(props) => props.theme.palette.themeSecondary + " !important"};
        font-weight: bolder;
    }
`;
export const PointsCont = styled.div`
    position: relative;
    display: block;
    margin: 0 auto;
    border: 1px solid #cc214f;
    border-radius: 50%;
    width: 25px;
    height: 25px;

    & span
    {
        display: block;
        position: absolute;
        height: 20px;
        font-size: 13px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;
export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Header = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px !important;
    gap: 20px;

    h3 {
        width: fit-content;
    }

    .flex10 {
         display: flex;
         gap: 10px;
    }
`;

export const CounterContainer = styled.div`
    display: flex;
    gap: 5px;
    align-items: center;
    font-weight: 800;
    font-size: 18px;
    flex-grow: 1;
    padding: 5px 0;
    color: ${(props) => props.theme.palette.neutralText};
    h3
    {
        margin: 0;
        font-size: 18px;
        font-weight: 800;
        color: ${(props) => props.theme.palette.black};
    }
`;
export const SearchContainer = styled.div`
    display: flex;
    position: relative;
    flex-grow: 1;
    font-size: 8px;
    background: ${(props) => props.theme.palette.tertiary};
    border-radius: 16px;
    padding: 0 5px 0 0;
    input
    {
        width: 100%;
        border-radius: 16px;
        border: none;
        color: ${(props) => props.theme.palette.neutralText};
        font-size: 14px;
        padding-left: 10px;
    }
    img
    {
        padding-left: 10px;
        padding-right: 5px;
        width: 14px;
    }
`;
export const ActionsContainer = styled.div`
    display: flex;
    button
    {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 5px;
        background: ${(props) => props.theme.palette.white};
        padding: 0 10px;
        border-radius: 16px;
        color: ${(props) => props.theme.palette.lightBlack};
        border: 1px solid ${(props) => props.theme.palette.neutralLighter};
        cursor: pointer;
    }
`;
export const TableContainer = styled.div`
    overflow-x: auto;
    display: flex;
    flex: 1;
`;
export const TableWrapper = styled.div`
    background: ${(props) => props.theme.palette.white};
    border-radius: 16px;
    box-shadow: 0px 0px 16px rgba(8, 84, 117, 0.08);
    padding: 25px 20px;
    margin-bottom: 20px !important;
`;
export const Table = styled.table`
    width: 100%;
    height: 100%;
    border-spacing: 0;
    text-align: left;

    thead
    {
        ${(props: any) =>
        {
            if(props.hasResume)
            {
                return`
                    th
                    {
                        padding: 17px;
                    }
                    tr:nth-child(2) th
                    {
                        background: ${props.theme.palette.tertiary};
                        font-weight: 500;
                    }`;
            }
            else
            {
                return `
                    th
                    {
                        background: ${props.theme.palette.tertiary};
                        padding: 17px;
                    }
                    th:first-of-type
                    {
                        border-top-left-radius: 10px;
                    }
                    th:last-of-type
                    {
                        border-top-right-radius: 10px;
                    }
                `;
            }
        }
    }
    td
    {
        padding: 16px;
        font-size: 12px;
        color: ${(props) => props.theme.palette.neutralText};
        > a
        {
            color: ${(props) => props.theme.palette.darkBorder};
            font-weight: 600;
            line-height: 20px;
            font-size: 14px;
            cursor: pointer;
        }
    }
    td:first-of-type
    {
        padding: 17px !important;
    }
`;

export const ActionsCell = styled.td`
    padding: 1em;

    span {
        vertical-align: baseline;

        svg {
            height: 20px;
            fill: ${(props) => props.theme.palette.themePrimary};
        }
    }
`;

export const ResumeHeader = styled.div`
    th:first-of-type
    {
        border-top-left-radius: 30px;
    }
    th:last-of-type
    {
        border-top-right-radius: 30px;
    }
    th
    {
        background: ${(props) => props.theme.palette.tertiary};
        padding: 17px;
    }
`;
